module.exports = __webpack_public_path__ + "img/logo01.4c0b3ab1.png";